export default __webpack_public_path__ + "static/Gatsby-3c0c69bf8f65cf0b01cc82e4813e6af6.png";